import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { getStoredAuth } from './utils';
import LoginScreen from './components/Auth/LoginScreen';
import installStaleBundleGuard from './services/staleBundleGuard';
import installSessionGuard from './services/sessionGuard';

// Recover stale tabs left on a previously-cached bundle after a deploy before we
// render anything (see staleBundleGuard for the why).
installStaleBundleGuard();

const root = document.getElementById('root');

const renderApp = () => ReactDOM.render(<App />, root);

const stored = getStoredAuth();

if (stored) {
  renderApp(stored);
  installSessionGuard();
} else {
  // No stored session — show the login gate (replaces the old prompt() flow).
  // Once `/login` succeeds the screen swaps itself out for the app.
  ReactDOM.render(<LoginScreen onAuthenticated={renderApp} />, root);
}

registerServiceWorker();
